import { useQuery } from '@tanstack/react-query';
import { getStoreBackstockLedger } from 'services/auditService';
import type { BackstockLedgerResponse } from '../../types';

export function useStoreBackstockLedger(
  storeId: string | null | undefined,
  startDate: string | null | undefined,
  endDate: string | null | undefined,
  enabled: boolean = true
) {
  return useQuery<BackstockLedgerResponse | null>({
    queryKey: ['store-backstock-ledger', storeId, startDate, endDate],
    queryFn: () => getStoreBackstockLedger(storeId!, startDate!, endDate!),
    enabled: enabled && !!storeId && !!startDate && !!endDate,
  });
}
